import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button from '../../../Button'
import { useGetClickHandlers } from '../DocFlowProfileHeaderActions.hooks'

function NextPhaseButton({
  completedPhase,
  nextPhaseDisabled,
  text = 'DocumentStapling.ProfileNextPhaseBtnKey',
  tooltip = 'DocumentStapling.ProfileNextPhaseDisabledBtnTooltipKey',
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClickNextPhase } = useGetClickHandlers(restProps)

  return (
    <Button.Contained
      disabled={completedPhase || nextPhaseDisabled}
      text={t(text)}
      tooltip={nextPhaseDisabled ? t(tooltip) : null}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClickNextPhase}
    />
  )
}

export default NextPhaseButton
